import { Form } from 'antd';
import ActionsStep from 'features/booking/BookingOnlineV2/ActionsStep';
import styled from 'styled-components';
import CustomerServicesStep, { customerServicesStepRef } from '../BookingOnlineV2/CustomerServicesStep';
import CustomerStep from './CustomerStep';
import DateStaffStep, { dateStaffStepRef } from '../BookingOnlineV2/DateStaffStep';
import HeaderStep, { titleRef } from './HeaderStep';
import ReviewStep from '../BookingOnlineV2/ReviewStep';
import SuccessStep from '../BookingOnlineV2/SuccessStep';
import TimeSlotStep, { timeSlotStepRef } from '../BookingOnlineV2/TimeSlotStep';

export type STEP_NAVIGATION = 'customer' | 'date_staff' | 'time_slot' | 'time' | 'service' | 'staff' | 'review' | 'success';
type Props = {
  value?: STEP_NAVIGATION;
};
const StepNavigation = ({ value: step }: Props) => {
  const form = Form.useFormInstance();
  const onBack = () => {
    setTimeout(() => {
      titleRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }, 10);
    if (step === 'date_staff') return form.setFieldValue('currentStep', 'service');
    if (step === 'time_slot') return form.setFieldValue('currentStep', 'date_staff');
    if (step === 'service') return form.setFieldValue('currentStep', 'customer');
    if (step === 'customer') {
      const categories = form.getFieldValue('categories');
      if (!categories.length) {
        setTimeout(() => {
          customerServicesStepRef.current?.fetch(form.getFieldValue('staff')?.id || '');
        }, 50);
      }
      return form.setFieldValue('currentStep', 'time_slot');
    }
    if (step === 'review') return form.setFieldValue('currentStep', 'customer');
  };

  if (step === 'success') return <Form.Item noStyle name={'appointment'}>
    <SuccessStep />
  </Form.Item>;

  return <>
    <HeaderStep step={step} />
    <Container>
      {step === 'date_staff' && <DateStaffStep ref={dateStaffStepRef} bookingOnlineV4={true}/>}
      {step === 'customer' && <CustomerStep />}
      {step === 'time_slot' && <TimeSlotStep ref={timeSlotStepRef} v3/>}
      {step === 'service' && <Form.Item noStyle name={'customers'}><CustomerServicesStep ref={customerServicesStepRef} v4={true}/></Form.Item>}
      {step === 'review' && <ReviewStep />}
    </Container>
    <ActionsStep
      onNext={step !== 'review' ? () => form.submit() : undefined}
      onBook={step === 'review' ? () => form.submit() : undefined}
      onDeposit={step === 'review' ? () => form.submit() : undefined}
      onBack={onBack} />
  </>;
};

export default StepNavigation;
const Container = styled.div`
min-height: 90vh;
border-radius: 24px 24px 0 0;
background: #FFF;
padding: 0 16px;
padding-top: 16px;
padding-bottom: 24px;
box-shadow: 0 -4px 8px -4px rgba(0, 0, 0, 0.15);
`;
